import moment from 'moment';
import { React, useState } from 'react';

const LeaseDetails = ({ leaseDetails, UnitDetails }) => {
    const rent = UnitDetails?.reduce((sum, row) => sum + (parseFloat(row?.Rent) || 0), 0);
    const vat = UnitDetails?.reduce((sum, row) => sum + (parseFloat(row?.VAT) || 0), 0);
    const total = UnitDetails?.reduce((sum, row) => sum + (parseFloat(row?.Total) || 0), 0);
    return (
        <div>
            <div className='gridshad mt-1'>
                <div className='table-container' style={{ overflowX: 'auto', height: "auto" }}>
                    <table>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Property</th>
                                <th>Unit No</th>
                                <th>Period Rent</th>
                                <th>Tax</th>
                                <th>VAT</th>
                                <th>Total</th>
                                <th>Type</th>
                                <th>Category</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(UnitDetails) && UnitDetails?.map((data, index) => (
                                <tr>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.PropertyName} disabled style={{ width: "400px" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.UnitNo} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.Rent?.toFixed(3)} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.Tax} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.VAT?.toFixed(3)} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.Total?.toFixed(3)} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.UnitType} disabled style={{ width: "100%" }} /></td>
                                    <td className='m-0 p-0'><input className='p-1' value={data?.UnitCategory} disabled style={{ width: "250px" }} /></td>
                                </tr>
                            ))}
                            <tr>
                                <td><input className='p-1 w-100' disabled value={""} /></td>
                                <td><input className='p-1 w-100' disabled value={""} /></td>
                                <td><input className='p-1 w-100' disabled value={rent?.toFixed(3) || "0.000"} /></td>
                                <td><input className='p-1 w-100' disabled value={""} /></td>
                                <td><input className='p-1 w-100' disabled value={vat?.toFixed(3) || "0.000"} /></td>
                                <td><input className='p-1 w-100' disabled value={total?.toFixed(3) || "0.000"} /></td>
                                <td><input className='p-1 w-100' disabled value={""} /></td>
                                <td><input className='p-1 w-100' disabled value={""} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="my-3 border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 2fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant NO</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.TenantNo} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Period From</label>
                        <input type="text" className="p-2 form-control w-75" value={moment(leaseDetails?.LeaseStart).format("DD-MMM-YYYY")} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant Name</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.TenantName} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Period to</label>
                        <input type="text" className="p-2 form-control w-75" value={moment(leaseDetails?.LeaseEnd).format("DD-MMM-YYYY")} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.MobileNo} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Lease Term</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.LeaseTerm || "0"} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.EmailId} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start text-bold">No. of Installments</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Installments || "0"} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Passport /  ID</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.IDNo || "0"} disabled />
                    </div>
                    <div></div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Nationality</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Nationality} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Person</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.LeasingAgent} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">VAT Reg NO</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.VATRegNo} disabled />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Agent</label>
                        <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Agent} disabled />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default LeaseDetails;